import React from 'react'
import axios from 'axios'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import ISchool from '@interfaces/ISchool'
import Routes from './routes/Routes'

import 'flexmonster/flexmonster.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './resources/scss/app.scss'

const token: string = localStorage.getItem('token') || ''
const school: ISchool = JSON.parse(localStorage.getItem('school') || '{}')
const year: number = Number(localStorage.getItem('year')) || new Date().getFullYear()

axios.defaults.baseURL = process.env.REACT_APP_API_URL
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
axios.defaults.headers.common['SchoolId'] = school?.id
axios.defaults.headers.common['Year'] = year

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
